import { ALBEvent, Context, ScheduledEvent, SQSEvent } from 'aws-lambda';
import { ErrorReqContext } from '../../common/ErrorReporter';
import { stripFields } from '../../utils/ObjUtils';
import type { CronLambdaInputEvent } from './scheduledActionsCronLambdaHandler';

type Event = ALBEvent | ScheduledEvent | SQSEvent | CronLambdaInputEvent;

export function errorReqContextFromLambda(event: Event, context: Context): ErrorReqContext {
    const reqContext = {
        context: {
            lambdaEvent: event,
            lambdaContext: context,
        },
        tags: { requestId: context?.awsRequestId },
    };

    if (!isEventALBEvent(event)) {
        return reqContext;
    }

    const ipAddress = event.headers?.['x-forwarded-for'] || '';

    const id = parseIdFromBody(event.body) || '';

    // Parse body in event.
    let body;
    try {
        body = JSON.parse(event.body!);
        body = stripFields(body, ['dataUrl']);
    } catch (e) {
        // tough luck, will just print the string
        body = event.body;
    }

    // We only care about the submitted body.
    // Sanitize body
    delete body.auth;

    const lambdaEvent = { body: JSON.stringify(body, null, 4) };
    const lambdaContext = { awsRequestId: context.awsRequestId, functionName: context.functionName };

    return {
        ...reqContext,
        user: { id, ipAddress },
        context: {
            ...reqContext.context,
            lambdaEvent,
            lambdaContext,
        },
        tags: {
            ...reqContext.tags,
            httpMethod: event.httpMethod,
            path: event.path,
        },
    };
}

function parseIdFromBody(body: string | null): string | null {
    if (body) {
        try {
            const parsedBody = JSON.parse(body);
            return parsedBody.id;
        } catch (e) {
            // Couldn't parse the user id, so leaving it undefined.
            return null;
        }
    }
    return null;
}

function isEventALBEvent(event: Event): event is ALBEvent {
    return !!(event as any).httpMethod;
}
